<template>
  <div v-if="order" class="order_panel after_border bgwhite" @click="gotoDetail">
    <div class="header">
      <div class="sn">订单号：{{ order.sn }}</div>
      <div class="status">{{ order.get_status_display }}</div>
    </div>
    <div class="body">

        <img class="cover" v-if="order.order_type=='clazz'" :src="order.clazz.cover_url">
        <img class="cover" v-if="order.order_type=='race'" :src="order.race.cover_url">

        <div class="info">

          <div class="title" v-if="order.order_type=='clazz'">{{ order.clazz.clazz_name }}</div>
          <div class="title" v-if="order.order_type=='race'">{{ order.race.name }}</div>

          <div class="cycle">{{ order.start_time_format2 }}～{{ order.end_time_format2 }}</div>
        </div>
      <div class="price">¥{{ order.total_amount }}</div>
    </div>
  </div>
</template>

<script>
import { Button } from 'vant'

export default {
  name: 'OrderPanel',
  components: {
    [Button.name]: Button
  },
  props: {
    order: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    gotoDetail () {
      this.$router.push('/order/' + this.order.sn + '/detail')
    },
    gotoPay () {
      this.$router.push('/order/' + this.order.uuid + '/confirm')
    },
    gotoClazz () {
      this.$router.push('/clazz/' + this.order.clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
  .order_panel {
    position: relative;
    padding: 20px 20px;
    margin: 0 20px 0;
    .header {
      display: flex;
      justify-content: space-between;
      font-size: 28px;
      .status {
        width: 100px;
        color: #f5222d;
      }
    }
    .body {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      padding-bottom: 20px;
      .cover {
        width: 80px;
        height: 80px;
        object-fit: cover;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 500px;
        margin-left: 20px;
        .title {
          font-size: 28px;
          font-weight: bold;
        }
        .cycle {
          font-size: 26px;
          color: #bbb;
        }
      }
      .price {
        width: 100px;
        font-size: 26px;
      }
    }
    .footer {
      height: 70px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn {
        width: 135px;
        height: 45px;
        font-size: 24px;
        border-radius: 25px;
        border: 1PX solid #7d7e80;
        color: #7d7e80;
        margin-left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.red {
          border: 1PX solid #f5222d;
          color: #f5222d;
        }
      }
    }
  }
</style>
